<template>
  <v-dialog
    v-model="modal"
    @input="closeDialog()"
    @keydown.esc="closeDialog()"
    width="840px"
    v-if="file !== null"
  >
    <v-card class="card-file">
      <v-btn small icon @click="closeDialog()" class="card-file-close"><v-icon small>mdi-close</v-icon></v-btn>
      <v-row class="no-gutters d-flex justify-space-between">
        <v-col cols="12" sm="6" class="order-1 order-sm-0 order-md-0 order-lg-0">
          <div :class="'card-capture pa-4 opa-' + backgroundMarket(file.marche)" style="min-height:200px">
            <div class="card-picture" :class="'bg-' + backgroundMarket(file.marche)">
              <span aria-hidden="true" :class="'fa ' + mimeIcon"></span>
            </div>
            <img
              alt=""
              class="responsive"
              :src="urlExtract + '/meta/files_images/' + file.pid + '_1.png'"
              v-if="file.extension === 'pdf'"
            />

            <img
              alt=""
              class="responsive"
              :src="urlExtract + '/meta/files_images/' + file.pid + '_1.png'"
              v-if="['png', 'jpg'].includes(file.extension)"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="6" class="order-0 order-sm-1 order-md-1 order-lg-1">
          <div class="pa-4">
            <h1 class="fileCategory">{{ i18nCategory(file.category) }}</h1>
            <p class="fileName">{{ file.name }}</p>
            <p>
              <v-btn
                color="primary"
                @click="openDocument(file.url)"
                class="text-left text-md-center pt-2 pb-2"
              >
                <span aria-hidden="true" :class="'mr-1 fa ' + mimeIcon"></span> 
                <span v-if="['video', 'videoMaintenance'].includes(file.category)">{{ $t('btn.watchVideo') }}</span>
                <span class="ml-2 ml-md-0" v-else>{{ $t('btn.download') }} <span class="d-block d-md-inline-block mt-1 mt-md-0">({{ file.extension }} - {{ humanSize }})</span></span>
              </v-btn>
            </p>
            <p class="fileLanguages mb-2">
              {{ $tc('theme.availableLanguage', file.languages.length) }}:<br/>
              <languages :data="file.languages" />
            </p>
            
            <p class="fileExtension mb-0" v-if="file.extension === 'pdf' && (file.fsMeta && Object.keys(file.fsMeta).length !== 0)">
              {{ $t('theme.pageCountLabel') }}: <span class="text-nowrap">{{ $tc('theme.pageCount', Object.keys(file.fsMeta).length) }}</span>
            </p>

            <p class="fileDuration mb-0" v-if="isVideo">
              {{ $t('theme.duration') }}: <span class="text-nowrap">{{ humanDuration }}</span>
            </p>
            <p class="fileSize mb-0" v-else>
              {{ $t('theme.size') }}: <span class="text-nowrap">{{ humanSize }}</span>
            </p>
            <p class="fileDate" v-if="file.fsCreated">
              {{ $t('theme.date') }}: <span class="fileDate text-nowrap">{{ $d(new Date(Date.parse(file.fsCreated)), 'short') }}</span>
            </p>

            <div class="fileMarket mt-2" v-if="file.marche.length !== 0">
              <p class="mb-0">{{ $tc('theme.availableMarket', file.marche.length) }}:</p>
              <market-icons
                size="20"
                :label="true"
                :items="file.marche"
              />
            </div>

            <div class="fileSector mt-2" v-if="file.secteur.length !== 0">
              <p class="mb-0">{{ $tc('theme.availableSector', file.secteur.length) }}:</p>
              <sector-icons
                size="10"
                :label="true"
                :items="file.secteur"
              />
            </div>

            <p class="fileMeta mb-2" v-if="file.fsMeta && Object.keys(file.fsMeta).length !== 0">
              <meta-data
                :mime="file.fsMime"
                :extension="file.extension"
                :meta="file.fsMeta"
                :pack="file.pack"
              />
            </p>
            
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import Mixins from '@/core/mixins'
import MetaData from '@/components/file/Meta'
import Languages from '@/components/file/Languages'
import MarketIcons from '@/components/file/Markets'
import SectorIcons from '@/components/file/Sectors'

const filesize = require('filesize')
const mimetype2fa = require('mimetype-to-fontawesome')({ prefix: 'fa-' })

export default {
  name: 'PumpModal',
  mixins: [ Mixins ],
  data () {
    return {
      fid: null,
      file: null,
      modal: false
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Languages,
    MarketIcons,
    SectorIcons,
    MetaData
  },
  destroy () {
    this.fid = null
    this.file = null
    this.modal = false
  },
  computed: {
    isVideo () {
      return ['videoMaintenance'].includes(this.file.category)
    },

    mimeIcon () {
      return mimetype2fa(this.file.fsMime)
    },

    humanSize () {
      return filesize(this.file.fsSize)
    },

    humanDuration () {
      const humanDuration = this.file.fsSize.replace("PT","").replace("H",":").replace("M",":").replace("S","")
      return humanDuration
    }
  },
  methods: {

    backgroundMarket (arr) {
      return Array.isArray(arr) && arr.length !== 0 ? arr[0].toLowerCase() : (typeof arr === "string" && arr !== "" ? arr.toLowerCase() : 'none')
    },

    async handlerFile (fid) {
      const data = await this.request(`/files/${fid}`)
      this.file = data
    },

    openDocument (url) {  
      setTimeout(() => {
        window.open(url, "_blank")
      }, 500)
    },

    openDialog (fid) {
      this.fid = fid
      this.handlerFile(fid)
      this.modal = true
    },

    closeDialog () {
      this.fid = null
      this.file = null
      this.modal = false
    }
  }
}
</script>
<style>
.card-file .card-capture {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-file .card-picture {
  margin: auto;
  position: absolute;
  z-index: 1;
}
.card-file .card-capture img {
  width: auto;
  max-width: 100%;
  height: auto;
  margin: auto;
  position: relative;
  z-index: 2;
  background: #ffff;
}
.card-file .v-btn {
  height: auto !important;
}
.v-btn--icon.card-file-close {
  position: absolute;
  right: .25em; top: .25em;
  height: 28px!important;
}
</style>
